import Icon from '../HOC/Icon'

export default function Unauthorized({ className }) {
  return (
    <div className={"flex flex-col gap-4 items-center justify-center w-full h-full "+className}>
      <Icon icon="mdi:lock" className="!w-96 !h-96 text-primary/5" />
    </div>
)
}
